import { UseFormRegister } from "react-hook-form";
import React from "react";
import classNames from "classnames";
import useRegisterPropOrFromContext from "components/shared/form/fields/useRegisterPropOrFromContext";

export default function Checkbox({
  name,
  register,
  label,
  disabled = false,
  className,
  required,
}: {
  name: string;
  label: string;
  register?: UseFormRegister<any>;
  disabled?: boolean;
  className?: string;
  required?: boolean | string;
}) {
  register = useRegisterPropOrFromContext(register);

  return (
    <label
      className={classNames("checkbox gap-2 items-center", className, {
        "text-muted": disabled,
      })}
    >
      <input
        type="checkbox"
        {...register(name, { required })}
        disabled={disabled}
      />
      {label}
    </label>
  );
}
